import React, { Component } from 'react';
import { connect } from 'react-redux';
import DeliveryTrackingModal from '../../../../views/app/common/modal/DeliveryTrackingModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class DeliveryTrackingModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'deliveryTrackingModal', value: false });
  };

  render() {
    return <DeliveryTrackingModal {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.deliveryTrackingModal.isOpen,
    data: state.app.deliveryTrackingModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(DeliveryTrackingModalContainer));
